<template>
  <div>
    <template v-if="!hasVoucherCode">
      <v-layout>
        <v-flex class="text-xs-center">
          <v-dialog v-model="isInputVoucherCode" persistent max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn
                small
                :color="theme.color"
                flat
                @click="isInputVoucherCode = true"
                v-on="on"
                >{{ $t('Have a voucher code') }}</v-btn
              >
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ $t('Voucher code') }}</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                        outline
                        autofocus
                        :color="theme.color"
                        v-model="promocode"
                        :label="$t('Enter voucher code')"
                        maxlength="20"
                        :error="hasError"
                        :error-messages="
                          hasError ? $t('Voucher code is not valid') : ''
                        "
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  flat
                  :color="theme.color"
                  @click="isInputVoucherCode = false"
                  :loading="loading"
                  >{{ $t('Cancel') }}</v-btn
                >
                <v-btn
                  dark
                  :color="theme.color"
                  @click="onCheckVoucher()"
                  :loading="loading"
                  >{{ $t('Confirm') }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
    </template>
    <template v-else-if="hasVoucherCode && promotion">
      <v-layout>
        <v-flex class="pl-3 pr-3 pt-2 pb-2">{{ $t('Subtotal') }}</v-flex>
        <v-flex shrink class="pl-3 pr-3 pt-2 pb-2 text-xs-right"
          >{{ currencySign }}{{ total | decimalFormat }}</v-flex
        >
      </v-layout>
      <v-layout>
        <template v-if="promotion.freeship">
          <v-flex class="pl-3 pr-3 pt-2 pb-2"
            >{{ $t('Discount')
            }}<a @click="clearpromocodeincart" class="ml-1"
              >({{ $t('Cancel') }})</a
            ></v-flex
          >
          <v-flex shrink class="pl-3 pr-3 pt-2 pb-2 text-xs-right">
            {{ $t('Free Delivery') }}
          </v-flex>
        </template>
        <template v-else-if="promotion.discountship > 0">
          <v-flex class="pl-3 pr-3 pt-2 pb-2"
            >{{ $t('Discount Shipping Fee')
            }}<a @click="clearpromocodeincart" class="ml-1"
              >({{ $t('Cancel') }})</a
            ></v-flex
          >
          <v-flex shrink class="pl-3 pr-3 pt-2 pb-2 text-xs-right">
            {{ currencySign }}{{ promotion.discountship | decimalFormat }}
          </v-flex>
        </template>
        <template v-else-if="promotion.discount > 0">
          <v-flex class="pl-3 pr-3 pt-2 pb-2"
            >{{ $t('Discount')
            }}<a @click="clearpromocodeincart" class="ml-1"
              >({{ $t('Cancel') }})</a
            ></v-flex
          >
          <v-flex shrink class="pl-3 pr-3 pt-2 pb-2 text-xs-right">
            {{ currencySign }}{{ promotion.discount | decimalFormat }}
          </v-flex>
        </template>
      </v-layout>
    </template>
  </div>
</template>

<script>
import VoucherCodeMixin from './VoucherCodeMixin.js'
export default {
  mixins: [VoucherCodeMixin]
}
</script>

<style lang="scss" scoped></style>
